export enum ContentType {
    Jpeg = 'image/jpeg',
    Docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    Pdf = 'application/pdf',
    Xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}
